const sortChanges = (first, second) => {
    if (first.change === "added" && second.change !== "added")
        return -1;
    else if (first.change !== "added" && second.change === "added")
        return 1;
    else
        return 0;
};
export const transformChanges = (changes) => {
    if (!changes)
        return {
            classificationChange: null,
            formatChange: null,
            functionalityChange: null,
            entropyChange: null,
            indicators: [],
            policies: [],
            sizeChange: null,
            tags: [],
            vulnerabilities: [],
            uris: [],
            actions: [],
        };
    /* Assuming there can be only one change for format, size, classification, functionality and entropy */
    const results = {
        formatChange: changes["format"] !== undefined ? changes["format"][0] : null,
        sizeChange: changes["size"] !== undefined ? changes["size"][0] : null,
        classificationChange: changes["classification"] !== undefined
            ? changes["classification"][0]
            : null,
        functionalityChange: changes["functionality"] !== undefined
            ? changes["functionality"][0]
            : null,
        entropyChange: changes["entropy"] !== undefined ? changes["entropy"][0] : null,
        tags: changes["tag"] !== undefined ? changes["tag"] : [],
        indicators: changes["indicator"] !== undefined ? changes["indicator"] : [],
        policies: changes["policy"] !== undefined ? changes["policy"] : [],
        vulnerabilities: changes["vulnerability"] !== undefined ? changes["vulnerability"] : [],
        uris: changes["uri"] !== undefined ? changes["uri"] : [],
        actions: changes["action"] !== undefined ? changes["action"] : [],
    };
    [...results.tags].sort((first, second) => sortChanges(first, second));
    [...results.indicators].sort((first, second) => sortChanges(first, second));
    [...results.policies].sort((first, second) => sortChanges(first, second));
    return results;
};
export const estimateDiffDetailsHeight = (count, changeType) => {
    const header = 46;
    const row = 36;
    const hashChange = changeType === "changed" ? 100 : 60;
    const tagChange = count.tag_count ? header + (count.tag_count / 2) * row : 0;
    const indicatorChange = count.indicator_count
        ? header + count.indicator_count * row
        : 0;
    const policyChange = count.policy_count
        ? header + count.policy_count * row
        : 0;
    return hashChange + policyChange + Math.max(tagChange, indicatorChange);
};
/**
 * Regular expression that captures the five logical parts of
 * an action change string, which is expected to be in format:
 * {on_event}.{event_name|unnamed}.{do_action}.{properties.key}={key_value}
 */
const ACTION_CHANGE_REGEX = /^(?<onEvent>[^.]+)\.(?<eventName>[^.]*)\.(?<action>[^.]+)\.(?<propertyKey>[^=]+)=(?<propertyValue>.*)$/;
/**
 * Diff "Action" Changes merge the properties of action_type_t/event_type_t
 * into a single string. This function returns the parsed out pieces.
 * @param changeString string - {on_event}.{event_name|unnamed}.{do_action}.{properties.key}={key_value}
 */
export const parseActionChange = (changeString) => {
    if (!changeString)
        return null;
    const match = changeString.match(ACTION_CHANGE_REGEX);
    if (!(match === null || match === void 0 ? void 0 : match.groups)) {
        return null;
    }
    const { onEvent, eventName: rawEventName, action, propertyKey, propertyValue, } = match.groups;
    // Event name may be missing, use "unnamed" default.
    const eventName = rawEventName === "" ? "unnamed" : rawEventName;
    return {
        onEvent,
        eventName,
        action,
        propertyKey,
        propertyValue,
    };
};
//# sourceMappingURL=diffUtils.js.map